export default __webpack_public_path__ + "static/media/Rocket V5 schuin.1d72de3c.mp4";